export function isInteractiveHtmlElement(htmlElement: HTMLElement): boolean {
  const nearbyAncestorElements = [
    htmlElement,
    htmlElement?.parentElement,
    htmlElement?.parentElement?.parentElement,
    htmlElement?.parentElement?.parentElement?.parentElement
  ];

  for (const nearbyAncestorElement of nearbyAncestorElements) {
    if (!nearbyAncestorElement) {
      continue;
    }

    if (
      nearbyAncestorElement instanceof HTMLButtonElement ||
      nearbyAncestorElement instanceof HTMLInputElement ||
      nearbyAncestorElement instanceof HTMLSelectElement ||
      nearbyAncestorElement instanceof HTMLTextAreaElement ||
      nearbyAncestorElement instanceof HTMLAnchorElement
    ) {
      return true;
    }
  }

  return false;
}
